"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isFunction = (value) => (typeof value === "function");
exports.default = isFunction;
